module.exports = __webpack_public_path__ + "static/media/procdna_logo.b3f93088.png";